import { createFileRoute, Link } from "@tanstack/react-router"
import { PageContainer } from "../components/layout/PageContainer"
import { useDocumentTitle } from "../hooks/common/useDocumentTitle"

export const Route = createFileRoute("/terms")({
	component: TermsPage,
})

function TermsPage() {
	useDocumentTitle("Terms")

	return (
		<PageContainer className="min-h-dvh py-14">
			<h1 className="text-balance font-display font-semibold text-4xl text-text-primary">Terms</h1>
			<p className="mt-4 text-base text-text-secondary">
				We will publish the full Terms of Service shortly. Please check back soon.
			</p>
			<Link
				className="mt-6 inline-flex min-h-[44px] items-center rounded-lg px-3 py-2 font-medium text-base text-text-muted hover:text-text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-text-primary focus-visible:ring-offset-2"
				to="/"
			>
				Back to markets
			</Link>
		</PageContainer>
	)
}
